/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-03
 */
import React, { Component } from 'react';
import { Dialog, FlatButton, TextField } from 'material-ui';
import { isEmpty } from 'lodash';
import GeneralInfo from './generalInfo';
import Expenses from './expenses';
import Totals from './totals';
import { DynamicTableV2 } from '../../components/data-containers';
import { Fieldset } from '../../components/layout';
import { gastosColumns, serviceColumns } from './definitions';
import { COINS } from '../../data/selects';
import Header from './header';
import FeeRow from './feeRow';
import { creditNote } from '../../data/preInvoice';
import {
    preInvoice as preInvoiceService,
    customerTabularPriceses as customerTabularPricesesService,
    invoiceItems as invoiceItemsService
} from '../../services';
import {
    buildPreInvoiceObject,
    getServicesTotals,
    getFeeAmount,
    getExpensesTotal,
    getTotals,
    isPreinvoiceValid
} from './helpers';
import Form from '../../forms';
import * as actions from '../../containers/conceptos/actions';
import { Confirmation } from '../../modals';

const servicesInit = [{ invoiceItem: '', applicableRepresentation: '', priceValue: 0, numberOfItems: 1, amount: 0 }];
const expensesInit = [{ invoiceItem: '', applicableRepresentation: '', amount: 0, numberOfItems: 1 }];
const feeInit = { customHouseValue: 0, feeValue: 0, minFee: 0, name: '', numberOfItems: 0, complementary: 0 };

const state = {
    services: servicesInit,
    expenses: expensesInit,
    fee: feeInit,
    preInvoiceTypeConfig: {},
    preInvoiceType: null,
    coin: COINS[0].id,
    advancePayment: 0,
    hasTabularPrices: false,
    conceptoOpen: false,
    errors: '',
    confirmationOpen: false
};

class Prefactura extends Component {
    constructor() {
        super();
        this.state = { ...state };
    }

    updateValue(value) {
        this.setState({ conceptoOpen: value });
    }

    loadFlete() {
        invoiceItemsService.get('invoiceItems', { concept: 'flete', projection: 'forListing' }).then(response => {
            const invoiceItem = response._embedded.invoiceItems[0];
            const serviceItem = {
                invoiceItem,
                numberOfItems: 1,
                amount: 0,
                useLabel: true
            };
            this.setState({ services: [serviceItem] });
        });
    }

    loadTabularPrices() {
        const { customClearence, customsHouses = [] } = this.props;
        const { customsHouse, customsValue, customer: { id }, type } = customClearence;
        const customsHouseId = customsHouses.find(c => c.uuid === customsHouse.id).uuid;
        const customerId = id.split('/').pop(-1);

        if (!customsHouseId) { return; }

        customerTabularPricesesService.getCustomTabularPrices({
            customsHouseId,
            customerId,
            projection: 'tabularForForm'
        }).then(data => {
            if (!data.length > 0) {
                this.setState({ errors: 'No se ha añadido ningún tabulador.' });
                return;
            }
            const feeData = data[0];
            const isFlat = feeData.tabularType === 'FLAT';

            customerTabularPricesesService.getExpensesTabularPrices({
                tabularId: feeData.id,
                projection: 'expensesForForm',
            }).then(expensesTabularPriceses => {
                const feeTypes = [
                    {
                        type: 'IMPORT',
                        customHouseValue: customsValue,
                        feeValue: feeData.importFee,
                        minFee: feeData.minimumImportFee,
                        name: 'MANUALMENTE',
                        numberOfItems: 1,
                        complementary: feeData.complementaryImportCharge,
                        flatValue: feeData.flatImportFee,
                        isFlat
                    },
                    {
                        type: 'EXPORT',
                        customHouseValue: customsValue,
                        feeValue: feeData.exportFee,
                        minFee: feeData.minimumExportFee,
                        name: 'MANUALMENTE',
                        numberOfItems: 1,
                        complementary: feeData.complementaryExportCharge,
                        flatValue: feeData.flatExportFee,
                        isFlat
                    }
                ];
                const services = expensesTabularPriceses.map(expensesTabularPrice => {
                    return {
                        ...expensesTabularPrice,
                        numberOfItems: 1,
                        amount: 0,
                        useLabel: true
                    };
                });
                const fee = feeTypes.find(feeType => feeType.type === type);
                this.setState({
                    services,
                    fee,
                    coin: feeData.currency || COINS[0].id,
                    hasTabularPrices: !isEmpty(feeData)
                });
            });
        });
    }

    loadCreditNote() {
        const services = [{ ...creditNote, useLabel: true, numberOfItems: 1 }];
        this.setState({ services });
    }

    render() {
        const { open, onClose, customClearence, onSave, preInvoiceCreated, isLoading, userData } = this.props;
        const { customer, folio } = customClearence;
        const {
            expenses,
            services,
            preInvoiceType,
            coin,
            preInvoiceTypeConfig,
            advancePayment,
            fee,
            hasTabularPrices,
            conceptoOpen,
            errors,
            confirmationOpen
        } = this.state;

        const feeAmount = hasTabularPrices ? getFeeAmount(preInvoiceTypeConfig, expenses, fee) : 0;
        const servicesTotals = getServicesTotals(preInvoiceTypeConfig, services, fee, feeAmount);
        const expensesTotal = getExpensesTotal(preInvoiceTypeConfig, expenses);
        const totals = getTotals(servicesTotals, expensesTotal, advancePayment);
        const userId = userData.userId;

        const extraInitialRow = fee.isFlat ?
            <FeeRow {...{ fee, feeAmount: fee.flatValue, feeTotalAmount: fee.flatValue, title: 'Tarifa FLAT', applicable: 'N/A', numberOfItems: 1 }} /> :
            <FeeRow {...{ fee, feeAmount: fee.complementary, feeTotalAmount: fee.complementary, title: 'COMPLEMENTARIOS', applicable: 'N/A', numberOfItems: 1 }} />;
        const feeRow = !fee.isFlat &&
            <FeeRow
                {...{ fee, feeAmount: feeAmount / fee.numberOfItems, feeTotalAmount: feeAmount, title: 'HONORARIOS', applicable: `${fee.feeValue} %`, numberOfItemsEditable: true, numberOfItems: fee.numberOfItems }}
                onChange={(value) => {
                    this.setState({ fee: { ...fee, numberOfItems: value } });
                }}
            />;

        if (isEmpty(customClearence)) { return null; }

        return (
            <div>
                <Dialog
                    title={<div>Prefactura<h5 style={{ color: 'red' }}>{errors}</h5></div>}
                    className="modalstyle"
                    open={open}
                    autoScrollBodyContent
                    contentStyle={{ width: '80%', maxWidth: 'none' }}
                    onRequestClose={onClose}
                >
                    {
                        isLoading ? <div>Guardando Prefactura... </div> : <div>
                            <Header
                                customerName={customer.name || ''}
                                preInvoiceType={preInvoiceType}
                                coin={coin}
                                onPreInvoiceTypeChange={(newPreInvoiceType, newPreInvoiceTypeConfig) => {
                                    this.setState({
                                        preInvoiceType: newPreInvoiceType,
                                        preInvoiceTypeConfig: newPreInvoiceTypeConfig,
                                        advancePayment: 0,
                                        services: servicesInit,
                                        expenses: expensesInit,
                                        fee: feeInit,
                                        errors: ''
                                    });

                                    newPreInvoiceTypeConfig.tabular && this.loadTabularPrices();
                                    newPreInvoiceTypeConfig.creditNote && this.loadCreditNote();
                                    newPreInvoiceTypeConfig.loadFlete && this.loadFlete();
                                }}
                                onCoinChange={(newCoin) => {
                                    this.setState({ coin: newCoin });
                                }}
                            />

                            <GeneralInfo {...customClearence} />

                            {
                                (!isEmpty(preInvoiceTypeConfig) && errors === '') &&
                                <div>
                                    {
                                        preInvoiceTypeConfig.services &&
                                        <Fieldset
                                            contentClass="margin-top-2 margin-bottom-2"
                                            legend="Servicios"
                                        >
                                            <DynamicTableV2
                                                selects={[]}
                                                columns={serviceColumns}
                                                data={services}
                                                extraRow={hasTabularPrices && preInvoiceTypeConfig.tabular && feeRow}
                                                extraInitialRow={hasTabularPrices && preInvoiceTypeConfig.tabular && extraInitialRow}
                                                notify={(value) => this.setState({ services: value })}
                                                validateRow={(row) => {
                                                    return (
                                                        row.numberOfItems > 0
                                                        && row.priceValue > 0
                                                        && !isEmpty(row.invoiceItem)
                                                    );
                                                }}
                                                Actions={{
                                                    onAddPreInvoice: () => {
                                                        this.updateValue(true);
                                                    }
                                                }}
                                            />

                                            <Expenses {...servicesTotals} preInvoiceTypeConfig={preInvoiceTypeConfig} />

                                        </Fieldset>
                                    }

                                    {
                                        preInvoiceTypeConfig.expenses &&
                                        <Fieldset
                                            contentClass="margin-top-2"
                                            legend="Relación de Gastos"
                                        >
                                            <DynamicTableV2
                                                selects={[]}
                                                columns={gastosColumns}
                                                data={expenses}
                                                notify={(value) => this.setState({ expenses: value })}
                                                validateRow={(row) => {
                                                    return !isEmpty(row.invoiceItem) && row.amount > 0;
                                                }}
                                                Actions={{
                                                    onAddPreInvoice: () => {
                                                        this.updateValue(true);
                                                    }
                                                }}
                                            />
                                        </Fieldset>
                                    }
                                    <Totals {...totals} coin={coin} preInvoiceTypeConfig={preInvoiceTypeConfig}>
                                        <TextField
                                            id="advancePaymentPreInvoice"
                                            inputStyle={{ textAlign: 'right' }}
                                            hintStyle={{ textAlign: 'right' }}
                                            fullWidth
                                            min="0"
                                            placeholder="$0.0"
                                            type="number"
                                            value={advancePayment}
                                            onChange={(event, value) => this.setState({ advancePayment: value })}
                                        />
                                    </Totals>
                                </div>
                            }

                            <div className="col-md-6 no-paddings margin-top-2 text-left">
                                <FlatButton
                                    label="Descargar Prefactura"
                                    disabled={isEmpty(preInvoiceCreated)}
                                    primary
                                    onTouchTap={() =>
                                        preInvoiceService.downloadFile({
                                            customsClearenceFolio: folio,
                                            preInvoiceSequence: preInvoiceCreated.folioSequence
                                        })}
                                />
                            </div>

                            <div className="col-md-6 no-paddings margin-top-2 text-right">
                                <FlatButton
                                    label="Cancelar"
                                    onTouchTap={() => onClose()}
                                />
                                <FlatButton
                                    label="Generar Prefactura"
                                    disabled={!isPreinvoiceValid(services, expenses)}
                                    onTouchTap={() => this.setState({ confirmationOpen: true })}
                                />
                            </div>
                        </div>

                    }
                </Dialog>
                <Form
                    title="Nuevo Concepto"
                    type="concepto"
                    open={conceptoOpen}
                    actions={{}}
                    onModalClosed={() => this.updateValue(false)}
                    onSave={(form) => {
                        actions.saveInvoiceItemFromPreInvoice(form);
                        this.updateValue(false);
                    }}//Will return if form is valid to send it
                />
                <Confirmation
                    open={confirmationOpen}
                    okLabel="Crear"
                    title="Creación de Prefactura"
                    message="¿Está seguro de crear la prefactura?"
                    onCancel={() => this.setState({ confirmationOpen: false })}
                    onConfirm={() => {
                        const data = buildPreInvoiceObject(
                            servicesTotals,
                            preInvoiceType,
                            totals,
                            advancePayment,
                            customClearence.id,
                            services,
                            expenses,
                            fee,
                            feeAmount,
                            userId,
                            coin
                        );
                        onSave(data);
                        this.setState({ ...state });
                    }}
                />
            </div>
        );
    }
}

export default Prefactura;



// WEBPACK FOOTER //
// ./forms/customPrefactura/index.js